/*
 * faq-detail.js -- přehrání videonávodu od vybrané kapitoly
 * (plán 16-02, komponenty `faq-video.php` a `faq-sidebar.php`).
 *
 * MECHANISMUS JE Z NÁVRHU, ZPŮSOB VLOŽENÍ NE. Návrh skládá přehrávač řetězením
 * HTML do vlastnosti, která rovnou parsuje značky. Tady se stejný výsledek
 * staví přes `createElement` a
 * `setAttribute`: identifikátor videa přichází z redakčního pole v administraci,
 * tedy z místa, kam může zapsat člověk, a řetězení HTML by z překlepu udělalo
 * vstupní bránu. Bezpečný způsob vložení není odchylka od návrhu -- výsledný DOM
 * je tentýž.
 *
 * IDENTIFIKÁTOR SE OVĚŘUJE PŘED POUŽITÍM. Stejný tvar jako v `youtube-facade.js`
 * (`^[A-Za-z0-9_-]{11}$`). Co neprojde, nespustí vůbec nic -- žádný přehrávač,
 * žádná výjimka, žádný text v DOM.
 *
 * PROČ NE ROVNOU `youtube-facade.js`. Ten nahradí náhled přehrávačem JEDNOU a
 * dál se o něj nestará. Tady musí jít přehrát opakovaně a pokaždé od jiné
 * sekundy, podle toho, na kterou kapitolu člověk klikne -- jiný model chování,
 * stejná bezpečnostní pravidla.
 *
 * BEZ SKRIPTU SE NIC NEZTRATÍ. Tlačítko i kapitoly jsou odkazy na YouTube,
 * takže bez JS se video otevře v novém panelu.
 */

const ID_RX = /^[A-Za-z0-9_-]{11}$/;
const ACTIVE_CLASS = 'active';

/**
 * Spustí ovládání kapitol videonávodu.
 *
 * @returns {void}
 */
export function init() {
	const box = document.getElementById('fqvid');

	if (!box) {
		return;
	}

	const youtubeId = box.getAttribute('data-yt') || '';

	if (!ID_RX.test(youtubeId)) {
		return;
	}

	const links = [].slice.call(document.querySelectorAll('.chaplist a'));
	const playButton = box.querySelector('.rplay');

	function play(start) {
		while (box.firstChild) {
			box.removeChild(box.firstChild);
		}

		const wrap = document.createElement('div');
		wrap.className = 'rvideo';

		const frame = document.createElement('iframe');
		const query = 'autoplay=1&playsinline=1&rel=0&modestbranding=1' + (start ? '&start=' + start : '');
		frame.setAttribute('src', 'https://www.youtube-nocookie.com/embed/' + youtubeId + '?' + query);
		frame.setAttribute('title', box.getAttribute('data-title') || 'video');
		frame.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; picture-in-picture; fullscreen');
		frame.setAttribute('allowfullscreen', '');

		wrap.appendChild(frame);
		box.appendChild(wrap);
	}

	if (playButton) {
		playButton.addEventListener('click', function (event) {
			event.preventDefault();
			play(0);
		});
	}

	links.forEach(function (link) {
		link.addEventListener('click', function (event) {
			event.preventDefault();

			links.forEach(function (other) {
				other.classList.remove(ACTIVE_CLASS);
			});
			link.classList.add(ACTIVE_CLASS);

			play(parseInt(link.getAttribute('data-t'), 10) || 0);
			box.scrollIntoView({ behavior: 'smooth', block: 'center' });
		});
	});
}
